import { degrees } from './degrees';

export const pathway = [
    {
        key: '6',
        name: 'What brings you to the Faculty of Education?',
        options: [
            {
                name: 'I want to advance my knowledge and education',
                value: '6.1',
            },
            {
                name: 'I want to become a counsellor',
                value: '6.2',
                results: true,
            },
            {
                name: 'I want to become a K-12 Teacher',
                value: '3.1.1',
            },
        ]
    },

    {
        key: '6.1',
        name: 'What credential are you interested in?',
        options: [
            {
                name: 'Post Baccalaureate Diploma',
                value: '6.1.4',
            },
            {
                name: 'Graduate Diploma',
                value: '6.1.3',
                results: true,
            },
            {
                name: 'Master’s Degree',
                value: '6.1.1',
            },
            {
                name: 'Doctoral Degree',
                value: '6.1.2',
            },
        ]
    },

    {
        key: '6.1.1',
        name: 'What areas of study are you interested in  ?',
        type: 'checkbox',
        maxSelection: 3,
        options: [
            ...degrees.graduateStudies
        ]
    },

    {
        key: '6.1.2',
        name: 'What areas of study are you interested in  ?',
        type: 'checkbox',
        maxSelection: 3,
        options: [
            ...degrees.graduateStudies
        ]
    },

    {
        key: '6.1.3',
        name: 'What areas of study are you interested in?',
        type: 'checkbox',
        results: true,
        hideDrawer: true,
        maxSelection: 3,
        options: [
            ...degrees.graduateDiploma,
        ]
    },

    {
        key: '6.1.4',
        name: 'What areas of study are you interested in?',
        type: 'checkbox',
        options: [
            ...degrees.postBach,
        ]
    }
];

export const results = [
    {
        id: '6.1.1',
        primary: {
            links: [
                ...degrees.graduateStudies
            ]
        },
        secondary: {
            links: [
                {
                    title: 'Doctoral Degree Programs',
                }
            ]
        }
    },
    {
        id: '6.1.2',
        primary: {
            links: [
                ...degrees.graduateStudies
            ]
        },
        footnote: {
            prerequisite: true,
            text: 'Review the {0} before completing your application.',
            links: [
                {
                    text: 'admission requirements for a Doctoral program',
                    url: 'https://www.sfu.ca/students/calendar/2022/spring/fees-and-regulations/grad-regulation.html#1.3.7a'
                }
            ]
        }
    },
    {
        id: '6.1.3',
        areasAsSubBullets: true,
        primary: {
            links: [
                {
                    title: 'Graduate Diploma Education (GDE)',
                    url: 'https://www.sfu.ca/education/programs/diplomas/gde.html'
                },

            ],
            degrees: [
                ...degrees.graduateDiploma
            ]
        },
        secondary: {
            links: [
                {
                    title: 'Master of Education in Educational Practice, MEd EP',
                    url: 'https://www.sfu.ca/education/programs/graduate-studies/programs/edpracticefp.html'
                }
            ]
        },
        footnote: {
            prerequisite: false,
            text: 'These programs are contemporary curriculum developed in collaboration with school districts and consultation with Faculty of Education faculty members. Learn about current offerings in your selected areas of study.'
        }
    },
    {
        id: '6.1.4',
        primary: {
            links: [
                ...degrees.postBach
            ]
        },
    },
    {
        id: '6.2',
        primary: {
            links: [
                {
                    title: 'Post Baccalaureate Diploma in Counselling and Human Development',
                    subtitle: 'Review the academic and experience prerequisites for the Master’s in Counselling Psychology programs',
                    url: 'https://www.sfu.ca/education/programs/professional-studies/post-bacc/counselling-human-development-pbd.html'
                },
            ]
        },
        secondary: {
            links: [
                {
                    title: 'Counselling Psychology MA, MEd',
                    url: 'https://www.sfu.ca/education/programs/graduate-studies/programs/counspsych.html '
                }
            ]
        }
    },
]
